/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Atelier_QuantityInputs */

const en_scene_atelier_quantity = /** @type {(inputs: Scene_Atelier_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qty`)
};

/**
* | output |
* | --- |
* | "Qty" |
*
* @param {Scene_Atelier_QuantityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_atelier_quantity = /** @type {((inputs?: Scene_Atelier_QuantityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Atelier_QuantityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_atelier_quantity(inputs)
});